import { useMemo, useRef, useState } from 'react';
import { FormInputProps } from '@/@types/form.types';
import EListPopupPickerWithSearchV2 from '@/components/everridge/EListPopupPickerWithSearchV2';
import { useTenantsSelectOptionsApi } from '@/features/superAdmin/features/tenants/hooks/useTenantsSelectOptionsApi';

type Props<T extends {}> = {
    selectVariant?: 'single' | 'multi';
    showSearch?: boolean;
    icon?: React.FC<React.SVGProps<SVGSVGElement>>;
    addResetButton?: boolean;
} & FormInputProps<T>;

const SuperAdminTenantLookup = <T extends {}>(props: Props<T>) => {
    const [searchValue, setSearchValue] = useState('');
    const { placeholder = 'Select tenant', label = 'Tenant', addResetButton = true } = props;
    const loaderRef = useRef<HTMLDivElement>(null);
    const { tenantsSelectData } = useTenantsSelectOptionsApi();

    const list = useMemo(() => {
        const items = (tenantsSelectData?.items ?? []).map((tenant) => ({
            id: tenant.id,
            name: tenant.name ?? tenant.id,
        }));
        const query = searchValue.trim().toLowerCase();
        if (!query) return items;
        return items.filter((item) => item.name.toLowerCase().includes(query));
    }, [searchValue, tenantsSelectData?.items]);

    return (
        <EListPopupPickerWithSearchV2
            {...props}
            label={label}
            placeholder={placeholder}
            list={list}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            addResetButton={addResetButton}
            ref={loaderRef}
        />
    );
};

export default SuperAdminTenantLookup;
